import { useCallback, useEffect, useState } from "react"
import { PendingsBoardService } from "../../../services/pendingsBoardService";
import { useNotifications } from "../../../hooks/useNotifications";


export const useUserPendingsBoardSettings = () => {
  const { showErrorNotification, showSuccessNotification } = useNotifications();
  const [isLoading, setIsLoading] = useState(false);
  const [userSettingData, setUserSettingData] = useState(null);

  const getUserBoardSettings = useCallback(async () => {
    setIsLoading(true);
    try {
      const userData = await PendingsBoardService.getUserBoardSettings();
      setUserSettingData(userData.boardSettings);
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecords',
      });
    } finally {
      setIsLoading(false);
    }
  }, [showErrorNotification]);

  const updateUserBoardSettings = useCallback(async (updateData) => {
    setIsLoading(true);
    try {
      await PendingsBoardService.updateUserBoardSettings(updateData);
      showSuccessNotification({
        title: 'success',
        description: 'successUpdatingRecord',
      });
      getUserBoardSettings()
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorUpdatingRecord',
      })
    } finally {
      setIsLoading(false);
    }
  }, [showSuccessNotification, showErrorNotification])

  useEffect(() => {
    getUserBoardSettings();
  }, [getUserBoardSettings])

  return {
    isLoading,
    userSettingData,
    getUserBoardSettings,
    updateUserBoardSettings,
  }

}